import {_getStartStyle, _getElStyle, getInputWid} from "./Common_Fun";
import EditorTypeUtils from "../../../common/editorTypeUtils";

let RadioBoxCtl = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        if (formType === "query") {
            return this.getEditorHtml(item, targetObj);
        } else {
            return this.getEditorHtml(item, targetObj);
        }
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getEditorHtml: function (
        {label, id, items, required},
        targetObj,
        inputWidth
    ) {
        let prefixCls = targetObj.prefixCls;

        //是否被选中
        function checkedStr(flag) {
            if (flag) {
                return "checked=true";
            } else {
                return "";
            }
        }

        //获取radio子项
        function _getRadioItems(items) {
            let rtAry = [];
            items&&items.forEach(function (sonItem) {
                rtAry.push(`
                 <label class="mt-radio mt-radio-outline">${sonItem.label}
                        <input idd="${prefixCls}_${id}" type="radio" ${checkedStr(sonItem.active)} ref="radio" value="${sonItem.value}"  name="${id}">
                        <span style="background-color: #FFF"></span>
                    </label> 
                `);
            });
            return rtAry.join("");
        } 
        return ` <div class="row go-form-row flex-div">
                    <div class="go-label" style="${_getElStyle(targetObj)}"><span class="start-require" ${_getStartStyle({required},targetObj)}>*</span>${label}：</div>
                     <div class="go-content ${getInputWid(inputWidth)}" style="position: relative;">
                      ${_getRadioItems(items)}
                    </div>
                </div>`;
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            this.getQuerySubmitData(item, targetObj, backJson);
        } else {
            this.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    //获取显示值
    getShowValue(curVal, item) {
        //循环子项 根据值获取label的显示值
        for (let num = 0; num < item.items.length; num++) {
            let itemObj = item.items[num];
            if (itemObj["value"] === curVal) {
                return itemObj["label"];
            }
        }
        return curVal || " ";
    },
    getRealValue(value) {
        return value || " ";
    },
    clearData(item, formType, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val("");
    },
    getQuerySubmitData: function (item, targetObj, backJson) {
        this.getEditorSubmitData(item, targetObj, backJson);
    },
    getEditorSubmitData: function (item, targetObj, backJson) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        //如果是radio选择框
        $("input[type='radio']").each(function () {
            let inputId = $(this).attr("idd");
            if (inputId === inputElId && $(this).prop("checked")) {
                backJson[item["id"]] = $(this).val();
            }
        });
    },
    initCtlEvent: function (parentObj) {
        //设置radio的初始值
        $(parentObj)
            .find("input[type='radio']")
            .each(function () {
                let inputId = $(this).attr("idd");
                //获取当前定义的字段属性
                let {defVal} = (EditorTypeUtils.itemTemp)[inputId];

                if (defVal === $(this).val()) {

                    $(this).attr("checked", true);
                }
            });
    }
};

export default RadioBoxCtl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/js-radio.js